import { environment } from '../../../../environments/environment';

/**
 * Loads the Google Maps JS API before the app bootstraps (APP_INITIALIZER).
 *
 * SECURITY NOTE: GOOGLE_KEY is a browser (client-side) API key. It is never
 * hard-coded in code — it is injected at build time from
 * process.env.NX_WEB_GOOGLE_KEY. In the future it will be sourced from
 * HashiCorp Vault in CI (see root .env.example / .gitlab-ci.yml).
 * Because the key ships to the browser, restrict it in Google Cloud Console
 * by HTTP referrer to the deployed domains and rotate it if exposed.
 */
export function googleMapsInitializer(document: Document) {
  return (): Promise<void> => {
    const key = environment.GOOGLE_KEY;
    if (!key) {
      console.warn(
        'NX_WEB_GOOGLE_KEY is not set; Google Maps features are disabled.'
      );
      return Promise.resolve();
    }

    if (typeof (document.defaultView as any)?.google !== 'undefined') {
      return Promise.resolve();
    }

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places&language=en`;
    script.async = true;
    script.defer = true;

    return new Promise<void>((resolve) => {
      script.onload = () => resolve();
      script.onerror = () => {
        console.error('Failed to load the Google Maps API script.');
        resolve();
      };
      document.head.appendChild(script);
    });
  };
}
